export const sortArray = (a, b, property) => {
  return String(a[property]).localeCompare(String(b[property]), undefined, { numeric: true });
};
